import useGuards from "api/Other/useGuards";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { currentPath, withReturnUrl } from "utils/intendedUrl";

const usePortalAccessGuard = () => {
	const location = useLocation();
	const history = useHistory();
	const { data, isFetched, isLoading } = useGuards();

	useEffect(() => {
		const blocker = data?.blocker;
		if (!isFetched || !blocker?.redirectPath) {
			return;
		}

		if (location.pathname === blocker.redirectPath) {
			return;
		}

		history.replace(
			withReturnUrl(blocker.redirectPath, {
				returnUrl: currentPath(location),
				code: blocker.code,
			})
		);
	}, [data, history, isFetched, location]);

	return {
		isCheckingAccess: isLoading && !isFetched,
	};
};

export default usePortalAccessGuard;
